var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import css from './BottomBar.scss';
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';

var BottomBar = function (_React$Component) {
  _inherits(BottomBar, _React$Component);

  function BottomBar() {
    _classCallCheck(this, BottomBar);

    return _possibleConstructorReturn(this, (BottomBar.__proto__ || Object.getPrototypeOf(BottomBar)).apply(this, arguments));
  }

  _createClass(BottomBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          commands = _props.commands,
          onClick = _props.onClick;

      return React.createElement(
        'div',
        { className: css.bottombar },
        commands.map(function (cmd) {
          return _this2._renderCommand(cmd, onClick);
        })
      );
    }
  }, {
    key: '_renderCommand',
    value: function _renderCommand(cmd, _onClick) {
      var node = null;
      if (cmd.tooltip) {
        node = React.createElement(
          Tooltip,
          { placement: 'top', alignment: 'center', content: cmd.tooltip, showTrigger: 'mouseenter', hideTrigger: 'mouseleave' },
          React.createElement(
            'div',
            null,
            cmd.node
          )
        );
      } else {
        node = cmd.node;
      }

      return React.createElement(
        'div',
        { className: css.command, onClick: function onClick() {
            return _onClick(cmd.id);
          }, key: cmd.id },
        node
      );
    }
  }]);

  return BottomBar;
}(React.Component);

BottomBar.propTypes = {
  commands: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired
};


export default BottomBar;
//# sourceMappingURL=BottomBar.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideBar/BottomBar.js